import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import {permissionObj} from "../../../../../Helpers/permission";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import TableFunction from "../../../../../components/table/TableFunction";
import {TABLES} from "../../../../../Apis/Tables";
import {
    SearchByFilters,
    SearchByFiltersCustom,
    SimpleSearch,
    SimpleSearchWithId
} from "../../../../../reduxToolkit/Search/SearchApi";
import routes from "../../../../../Routes/routes";
import {
    CRITERIA_MODEL, DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX,
    SEARCH_MODEL
} from "../../../../../components/table/Model/TableModel";
import {EMPTY_VALUES, getFullName} from "../../../../../Apis/functions";
import {DetailsIconsOptions, IconPersonPhoto, UpdateIconsOptions} from "../../../../../components/buttons/IconButtons";
import {TABS_PROVIDER} from "../../../Model/Model";
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @param {boolean} search - Flag to determine if search mode is active.
 * @param {number|null} supplierId - ID of the supplier to filter by, if any.
 * @param {string} searchElement - Text input for simple search queries.
 * @param {number|null} contractorId - ID of the contractor to filter by, if any.
 * @param {Array} finalArray - Array of advanced search criteria.
 * @param setBodyForExport
 * @param setCriteria
 * @constructor
 */


export const SuppliersTableApp = ({
    view,
    supplierId,
    searchElement,
    contractorId,
    finalArray,
    setModified,
    modified,
    setBodyForExport,
    setCriteria,
    setIsAllChecked,
    selectedList,
    setSelectedList
}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const tableId = "tbl_sta_suppliers";
    const searchId = "txt_sta_suppliers";
    const option = `${TABLES.SUPPLIERS}`;
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_SUPPLIER_DELETE)) && supplierId === null;
    const leftPosition = deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('company_name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('email')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('phone_number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if(!results || results?.content?.length === 0)
            return {body: [], data: [],};

        let body =  results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixedXY={true} left={leftPosition}>     <CustomTooltip
        text={`${item?.acronym} | ${item?.supplierCompanyName}`}
        classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis`}
        showIfTruncated={true}
    />

                    </CustomTd>
                    <CustomTd tableId={tableId} >
                        <CustomTooltip
                            text={item?.fullName || `${getFullName(item?.name, item?.lastName, item?.secondLastName)}`}
                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis`}
                            showIfTruncated={true}
                        />
                        </CustomTd>
                    <CustomTd tableId={tableId} >{item?.email || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.phoneNumber || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            fontColor={statusFontColor[item?.statusId]}
                            borderColor={statusBorderColor[item?.statusId]}
                            background={statusColor[item?.statusId]}
                            legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });
        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = (item, index) => {
        return <>
    
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    {(DEV || permission?.includes(permissionObj?.WEB_SUPPLIER_UPDATE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('update')}
                            click={() =>  {
                                navigate(routes.suppliers.updateSuppliers+ item.id,
                                    {
                                        state: {
                                            backUrl: routes.suppliers.main,
                                            currentTab: TABS_PROVIDER.SUPPLIERS.INDEX,
                                        }
                                    }
                                );
                            }}
                            icon={<UpdateIconsOptions />}
                        />
                    )}

                    <DropDownMenuItem
                        id={"btn_sta_details_"+ item?.id}
                        index={index}
                        handleClose={handleClose}
                        name={ t('details')}
                        click={() =>  {
                            navigate(routes.employee.suppliersDetails +  item?.id,
                                { state: {
                                        backUrl: routes.suppliers.main,
                                        currentTab: TABS_PROVIDER.SUPPLIERS.INDEX,
                                    }
                                }
                            );
                        }}
                        icon={ <DetailsIconsOptions/> }
                    />
                     <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('validation_identity')}
                            icon={<IconPersonPhoto />}
                            click={() => {
                              navigate(routes.employee.suppliersIdentityValidation +  item?.userId,
                                { state: {
                                        backUrl: routes.suppliers.main,
                                        currentTab: TABS_PROVIDER.SUPPLIERS.INDEX,
                                    }
                                }
                            );
                            }}
                        />
                </DropDownMenuProfile>
        </>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = supplierId === null ?
            SEARCH_MODEL.setObject({page, size: rowsPerPage, model:option,key: searchElement, view }) :
            SEARCH_MODEL.setObject({page, size: rowsPerPage, model:option,key: searchElement,userId: supplierId, view })

        setBodyForExport(body);
        const dispatchFunction = supplierId === null ? SimpleSearch : SimpleSearchWithId;
        dispatch(dispatchFunction({ body })).then(({payload: {data: { data, success }}}) => {
            if (success === true) {
                setResults(data);
            }
        });
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const isCustom = contractorId !== null || supplierId !== null;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            view,
            ...(supplierId && { userToFindId: supplierId }),
        });
        setCriteria(body);
        const action = isCustom ? SearchByFiltersCustom : SearchByFilters;
        dispatch(action({ option, body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setResults(data);
        });
    };

    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        page,
        rowsPerPage
    } = TableFunction({
        selectedList, // Current selection, needed to keep the select all checkbox in sync
        setSelectedList,
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage:'suppliers_per_page',
        fixedPagination:false,
        hasContainer:true,
        setIsAllChecked,
        searchElement,//New
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    return {
        t,
        navigate,
        DEV,
        permission,
        tableId,
        searchId,
        thead,
        tbody,
        option,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        setResults,
        page,
        rowsPerPage,
        deletePermission
    }
}
